var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "info_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h32v32H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#info_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 22.333a.974.974 0 00.717-.283.974.974 0 00.283-.717v-5.7a.934.934 0 00-.283-.684.975.975 0 00-.717-.283.97.97 0 00-.716.283.972.972 0 00-.284.717v5.7c0 .267.094.495.284.684a.97.97 0 00.716.283zm0-9.933c.31 0 .566-.106.766-.318.2-.21.3-.471.3-.782 0-.29-.1-.54-.3-.751a1.01 1.01 0 00-.766-.316 1.01 1.01 0 00-.767.316c-.2.212-.3.462-.3.75 0 .312.1.573.3.783.2.212.456.318.767.318zm0 16.266c-1.756 0-3.406-.333-4.95-1-1.545-.666-2.884-1.566-4.017-2.7C5.9 23.833 5 22.494 4.333 20.95c-.667-1.544-1-3.194-1-4.95 0-1.755.333-3.405 1-4.95C5 9.505 5.9 8.166 7.033 7.033 8.166 5.9 9.505 5 11.05 4.333c1.544-.667 3.194-1 4.95-1 1.755 0 3.405.333 4.95 1 1.544.667 2.883 1.567 4.016 2.7 1.134 1.133 2.034 2.472 2.7 4.016.667 1.545 1 3.195 1 4.95 0 1.756-.333 3.406-1 4.95-.666 1.545-1.566 2.884-2.7 4.017-1.133 1.134-2.472 2.034-4.016 2.7-1.544.667-3.195 1-4.95 1zm0-2c2.955 0 5.472-1.038 7.55-3.116 2.078-2.078 3.116-4.595 3.116-7.55 0-2.956-1.038-5.473-3.116-7.551-2.078-2.077-4.595-3.116-7.55-3.116-2.956 0-5.472 1.039-7.55 3.116-2.078 2.078-3.117 4.595-3.117 7.55 0 2.956 1.04 5.473 3.117 7.551 2.078 2.078 4.594 3.116 7.55 3.116z",
    fill: "#005499"
  }))));
}
export default __webpack_public_path__ + "assets/static/media/info.d727384f.svg";
export { SvgInfo as ReactComponent };